// Keep organization HTML inert while retaining the formatting used by the default terms.
export function sanitizeTermsHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const allowed = new Set(['DIV', 'P', 'SPAN', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI',
        'STRONG', 'B', 'EM', 'I', 'U', 'BR', 'HR', 'A', 'BLOCKQUOTE', 'TABLE', 'THEAD', 'TBODY', 'TR', 'TH', 'TD'])
    for (const element of [...doc.body.querySelectorAll('*')]) {
        if (!allowed.has(element.tagName)) {
            element.remove()
            continue
        }
        for (const attr of [...element.attributes]) {
            const safeLink = element.tagName === 'A' && attr.name === 'href' && /^(https?:|mailto:)/i.test(attr.value.trim())
            if (attr.name !== 'class' && !safeLink) element.removeAttribute(attr.name)
        }
        if (element.tagName === 'A') element.setAttribute('rel', 'noopener noreferrer')
    }
    return doc.body.innerHTML
}
